import CreateBrandContainer from "@containers/dashboard/brands/create";
import DashboardLayout from "@layouts/dashboard";

const CreateBrand = () => {
    return (
        <DashboardLayout title="برند جدید">
            <CreateBrandContainer />
        </DashboardLayout>
    );
};

export default CreateBrand;
